// extracted by mini-css-extract-plugin
module.exports = {"main-component":"cross_main-component__h6bC5"};